<template>
  <div class="card p-2" v-if="liveLocatorData != null">
    <div class="card-body p-2">
      <div class="d-flex align-items-center">
        <div class="image">
          <img :src="liveLocatorData.user.avatar.lgUrl" alt="Image" class="circular-image"
            style="height: 60px; width: 60px">
        </div>
        <div class="card-content">
          <small class="text-yellow mb-1"> You are viewing</small>
          <h4 class="display-5 mb-0"><strong>{{ liveLocatorData.user.displayName }}</strong></h4>
          <small class="text-muted">Started: {{ liveLocatorData.createdAt }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  props: {
    toggleMap: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState({
      liveLocatorData: (state: any) => state.liveLocator.liveLocatorData,
      distance: (state: any) => state.liveLocator.distance,
      elevationGain: (state: any) => state.liveLocator.elevationGain,
    }),
    time() {
      const durationMinutes = this.liveLocatorData.durationMinutes;
      if (durationMinutes < 60) {
        return durationMinutes + " mins";
      } else {
        const hours = Math.floor(durationMinutes / 60);
        const minutes = durationMinutes % 60;
        return hours + "h " + minutes + "m";
      }
    },
  },
});

</script>

<style scoped>
.card {
  position: absolute;
  bottom: 30px;
  left: 30px;
  right: 0;
  width: 370px;
  z-index: 100;
  border-radius: 10px;
}

.circular-image {
  border-radius: 50%;
}

.image {
  margin-right: 20px;
}

.card-content {
  text-align: left;
}

.card-content h2 {
  font-size: 24px;
  margin: 0 0 10px 0;
}

.card-content h3 {
  font-size: 18px;
  margin: 0 0 10px 0;
}

@media (max-width: 768px) {
  .card {
    left: 0;
    margin: auto;
    width: 90%;
  }
}
</style>
